import { Route, Routes } from "react-router-dom";
import { OSCI0102001Q } from "../mypg/todo/OSCI0102001Q";
import { OSCI0102002Q } from "../mypg/iqs/OSCI0102002Q";
import { OSCI0102003S } from "../mypg/iqs/OSCI0102003S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const MyPageRouter = () => {
    return (
        <Routes>
            {/** ==================== Apply for User Registration START ==================== */}

            {/* Check user registration application information !== 사용자 등록 신청 정보 조회 ==! */}
            <Route path={"/todo/osci0102001q"} element={<OSCI0102001Q />} />

            {/** ==================== Apply for User Registration END ==================== */}

            {/** ==================== IQS START ==================== */}
            {/* PTLO */}
            {/* My IQS List !== My IQS 목록 ==! */}
            <Route path={"/iqs/osci0102002q"} element={<OSCI0102002Q />} />
            {/*  My IQS Detail !==  My IQS 상세 ==! */}
            <Route path={"/iqs/osci0102003s/:iqsId"} element={<OSCI0102003S />} />
            {/** ==================== IQS START END ==================== */}
        </Routes>
    );
};
